import React from "react";
import { Routes, Route } from "react-router-dom";
import { SearchProvider } from "@elastic/react-search-ui";
import "@elastic/react-search-ui-views/lib/styles/styles.css";

import searchConfig from "../searchui/createSearchConfig";

import AppLayout from "./AppLayout";
import HomePage from "./HomePage";
import FirearmPage from "./FirearmPage";
import FirearmsG4 from "./FirearmsG4";
import NotFoundPage from "./NotFoundPage";

export default function App() {
  return (
    <SearchProvider config={searchConfig}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/firearm/:slug" element={<FirearmPage />} />
          <Route
            path="/firearms-potentially-affected-by-amendment-g4"
            element={<FirearmsG4 />}
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </SearchProvider>
  );
}
